// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"ac1ee637","245":"c365fff7","357":"478aee01","498":"d1397a03","619":"c5a03de3","748":"feab3ddf","834":"0c9bd725"}[chunkId] + ".chunk.js";
};